// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c7aee2b","455":"5b94d1de","977":"06843cd1"}[chunkId] + ".chunk.js";
};